<template>



    <div class="main-nav">
        <div class="nav-container">
            <div class="header-bar">
                <svg class="logo" viewBox="0 0 218.18 22" id="paychexbeta_logo" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M20.77 7.26c0-4.65-2.46-6.76-6.24-6.76H4.3L0 21.5h6.27l1.3-6.34h4.28c5.42.01 8.92-3.64 8.92-7.9zM11 10.16H8.61l.89-4.29h2.16c1.33 0 2.75.27 2.75 1.89 0 1.43-.83 2.4-3.41 2.4zM26.79.51l-11.92 21h6.47l1.59-3h6.73l.35 3h6.23L33 .51zM25.23 14l3.21-6.29h.06l.69 6.29h-4zM48.93.51l-5 7.82-2-7.82h-6.4L40 13.8l-1.56 7.7h6.35l1.56-7.76 10-13.23zm17 13c-.4 1.85-1.53 3.23-3.52 3.23-2.92 0-3.33-2.7-3.33-4.44 0-3 1.27-7.07 4.8-7.07 2 0 2.89 1.12 2.83 3.08h6C72.55 2 68.45 0 63.85 0c-7 0-11.19 5.66-11.19 12.44 0 5.56 2.89 9.56 8.87 9.56 8.58 0 10.2-6.34 10.58-8.48h-6.18zm22.63-13L87 7.86h-5.8L82.7.5h-6.32l-4.3 21h6.35l1.7-8.27h5.8l-1.7 8.27h6.35l4.35-21h-6.37zm38.24 0L122.68 6l-2-5.47H97.1l-4.31 21h23.76l4.76-5.87 2.28 5.87h7.13l-5-11.14L134.3.53h-7.54zm-16.31 19l.7-3.42h-10.94l.55-2.66h9.94l1-5h-9.91l.55-2.61h10.69L114 1l4.48 9.35zm38.14-10.27l1-4.85h7.78l3.37-3.88h-14.92l-4.44 21H146l1.85-8.67h6.26l3.1-3.59h-8.58zm13.92 8.38L166.14.5h-4.64l-4.41 21h12.26l3.32-3.88zm15.47 0l1.09-5.15 6.35-.07 3-3.52h-8.63l.94-4.5h7.8L191.82.5H177l-4.41 21h12.7l3.36-3.88h-10.63zM211.29.51h-5.47l-5.38 6.94-3-6.94h-5l4.91 9.94-9.56 11.05h5.59l6-7.5 3.29 7.5h5.09l-5.2-10.85zM215.18 0a3 3 0 0 0-3 3.07 3 3 0 0 0 3 3.07 3 3 0 0 0 3-3.07 3 3 0 0 0-3-3.07zm0 5.65a2.52 2.52 0 0 1-2.53-2.59 2.53 2.53 0 1 1 5.05 0 2.45 2.45 0 0 1-2.52 2.59zm1.38-3.43c0-.6-.36-1-1.14-1h-1.32v3.59h.42V3.25h.72l1 1.56h.48l-1-1.56c.48-.12.84-.36.84-1.02zm-1.44.6h-.54v-1.2h.78c.42 0 .84.12.84.6s-.54.61-1.08.61z" fill="#fff"></path></svg>
            </div>

            <div class="app-links">
                <div class="app-group-header">
                    <span>MAIN</span>
                </div>
                <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="dashboard")'  @click="onNavLink('dashboard:dashboard')">
                    <div class="app-link-icon">
                        <svg viewBox="0 0 30 30" id="dashboard" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M15 7a8 8 0 1 1-8 8 8 8 0 0 1 8-8m0-1a9 9 0 1 0 9 9 9 9 0 0 0-9-9z" ></path><circle cx="14.92" cy="9" r="1" ></circle><circle cx="21" cy="15" r="1" ></circle><circle cx="10.76" cy="10.76" r="1" ></circle><circle cx="19.24" cy="10.76" r="1" ></circle><circle cx="9" cy="15" r="1" ></circle><path d="M15 11s-2 6.9-2 8a2 2 0 0 0 4 0c0-1.1-2-8-2-8zm-.08 9a1 1 0 1 1 1-1 1 1 0 0 1-1 1z" ></path></svg>
                    </div>
                    <div class="app-link-label">
                        <span>Dashboard</span>
                    </div>
                </div>
                <div class="app-link" :data-selected='(activeAppLink=="company:analytics")' >
                    <div class="app-link-icon">
                        <svg viewBox="0 0 30 30" id="report-center" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M13.88 22.83H6.94V7.16h10.59v2.21h2.35v2.79a6.59 6.59 0 0 1 1.09.31V8.16l-1.72-1.64-.54-.52H6.53a.69.69 0 0 0-.7.67v16.65a.69.69 0 0 0 .7.67h8.71a6.52 6.52 0 0 1-1.36-1.16" ></path><path d="M18.47 17.91l2-4.58A5.47 5.47 0 0 0 15 14.46zM19.12 18.17h5.06a5.49 5.49 0 0 0-3.06-4.57zM18.93 18.87V24a5.48 5.48 0 0 0 5.24-5.13h-5.24zM18.23 18.67L14.52 15a5.48 5.48 0 0 0 3.7 9v-5.33zM15.44 12.93H8.6v1.21h5.34a6.45 6.45 0 0 1 1.5-1.21M8.6 9.7h4.04v1.21H8.6zM8.6 16.16v1.21h3.73a6.29 6.29 0 0 1 .34-1.21H8.6zM8.6 19.4v1.21h4a6.41 6.41 0 0 1-.28-1.21H8.6z" ></path></svg>
                    </div>
                    <div class="app-link-label">
                        <span>Analytics & Reports</span>
                    </div>
                </div>
                <div class="app-link" :data-selected='(activeAppLink=="company:payroll")' >
                    <div class="app-link-icon">
                        <svg viewBox="0 0 30 30" id="payroll" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M16.48 13.13c-.66-.24-1.3-.52-1.22-1a1.19 1.19 0 0 1 1.32-.72 2.77 2.77 0 0 1 1.87.77l.26.24 2-3.07-.21-.17a6.09 6.09 0 0 0-2.81-1L18 6h-2.2l-.33 2.13a5.13 5.13 0 0 0-4.2 4.33c-.37 2.34 1.07 3.23 2.36 3.75l.81.29c1.07.36 1.52.57 1.45 1a1.49 1.49 0 0 1-1.52 1 4 4 0 0 1-2.67-1.36l-.26-.28-2.18 3.2.16.18a5.18 5.18 0 0 0 2 1.23 6 6 0 0 0 1.92.44L13 24h2.2l.35-2.24c2.54-.67 4-2.12 4.33-4.46.44-2.81-1.75-3.59-3.41-4.18" ></path><path d="M16.48 13.13c-.66-.24-1.3-.52-1.22-1a1.19 1.19 0 0 1 1.32-.72 2.77 2.77 0 0 1 1.87.77l.26.24 2-3.07-.21-.17a6.09 6.09 0 0 0-2.81-1L18 6h-2.2l-.33 2.13a5.13 5.13 0 0 0-4.2 4.33c-.37 2.34 1.07 3.23 2.36 3.75l.81.29c1.07.36 1.52.57 1.45 1a1.49 1.49 0 0 1-1.52 1 4 4 0 0 1-2.67-1.36l-.26-.28-2.18 3.2.16.18a5.18 5.18 0 0 0 2 1.23 6 6 0 0 0 1.92.44L13 24h2.2l.35-2.24c2.54-.67 4-2.12 4.33-4.46.44-2.81-1.75-3.59-3.41-4.18" ></path></svg>
                    </div>
                    <div class="app-link-label">
                        <span>Payroll Center</span>
                    </div>
                </div>
                <div class="app-link ">
                    <div class="app-link-icon">
                        <svg viewBox="0 0 30 30" id="people" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><title>applicationIcons</title><path d="M19.8 10.25a1.75 1.75 0 0 1 .1 3.5 1.84 1.84 0 0 1-1.8-1.7 1.65 1.65 0 0 1 1.7-1.8m0-1a2.75 2.75 0 1 0 2.7 2.8 2.78 2.78 0 0 0-2.7-2.8zM12.4 8.15a3 3 0 0 1 2.9 3 2.9 2.9 0 1 1-5.8.3v-.3a3 3 0 0 1 2.9-3m0-1a3.93 3.93 0 0 0-3.9 4 3.85 3.85 0 0 0 3.7 4.1 3.91 3.91 0 0 0 4.1-3.7v-.4a3.93 3.93 0 0 0-3.9-4zM25.8 19.35a3 3 0 0 0-1-2 7.09 7.09 0 0 0-5-1.7 8.42 8.42 0 0 0-2.7.4 9.44 9.44 0 0 0-.9.3 8.22 8.22 0 0 0-3.8-.6 11.93 11.93 0 0 0-3.7.6 6.91 6.91 0 0 0-4 3.1 3.87 3.87 0 0 0-.5 2.4.92.92 0 0 0 .9 1h14.4c1 0 1.2-1 1-2H25c.8 0 .9-.85.8-1.5zM19.6 21a1.39 1.39 0 0 1 0 .9H5.2v-.1a2.78 2.78 0 0 1 .3-1.8A6.34 6.34 0 0 1 9 17.25a10.24 10.24 0 0 1 3.5-.5 12.41 12.41 0 0 1 2.7.3 4.87 4.87 0 0 1 1.1.4 6.36 6.36 0 0 1 2.2 1.4 3.92 3.92 0 0 1 .8 1c.1.3.2.7.3 1.1zm5.2-1.1h-4.5a4.52 4.52 0 0 0-1.1-1.7 6.57 6.57 0 0 0-1.7-1.2 9.69 9.69 0 0 1 2.3-.3 6.13 6.13 0 0 1 4.3 1.5 2.22 2.22 0 0 1 .8 1.3.76.76 0 0 0-.1.35z" ></path></svg>
                    </div>
                    <div class="app-link-label">
                        <span>People</span>
                    </div>
                </div>



                <hr class="app-group-header" />
                <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="hb")' @click="onNavLink('hb:hb-summary')">
                    <div class="app-link-icon">
                        <svg viewBox="0 0 30 30" id="health-and-benefits" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M16.06 13.1a1.21 1.21 0 0 0 1-.94 1 1 0 0 0-.65-1 2.8 2.8 0 0 0-.9-.27v2.27h.2l.31-.06m6.38-5.65A26 26 0 0 0 15.15 6 29.46 29.46 0 0 0 7.6 7.45s-.87 8.45 2.56 13C12.52 23.52 14.92 24 15 24c.07 0 2.47-.48 4.84-3.59 3.43-4.51 2.56-13 2.56-13m-5.63 9a.86.86 0 0 1 .9.6 1.2 1.2 0 0 1-.79 1.16 4 4 0 0 0-1.33 1.05v1.18h-.8a3.42 3.42 0 0 1-.3-1 1.1 1.1 0 0 1 .3-.77V17c-1.46-.43-2.2-1-2.2-1.73 0-.9.74-1.54 2.2-1.93V11A2.33 2.33 0 0 0 13 12.78l-.27-1-.88.33v-.15a3 3 0 0 1 2.35-2.19 1.08 1.08 0 0 1-.09-.44 1 1 0 1 1 2.08 0 1.16 1.16 0 0 1-.12.52 2.73 2.73 0 0 1 2.13 2.24c0 1.1-.75 1.82-2.1 2l-.54.1v2a8.58 8.58 0 0 0 1.22.21m-3.28-1.14c0 .15.34.42 1.26.72v-1.6c-.81.26-1.26.57-1.26.89M15.55 18a10.1 10.1 0 0 1 .94-.58c-.23 0-.56-.08-.94-.17V18z" ></path></svg>
                    </div>
                    <div class="app-link-label">
                        <span>Health & Benefits</span>
                    </div>
                </div>

                <hr class="app-group-header" />
                <div class="app-group-header">
                    <span>OTHER</span>
                </div>

                <div class="app-link" @click="onNavLink('otherModules',3)">
                    <div class="app-link-icon">
                        <svg viewBox="0 0 30 30" id="help" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M24 15a9 9 0 0 0-18 0 9 9 0 0 0 18 0zm-7.88 4.9a.55.55 0 0 1-.56.55h-1.12a.55.55 0 0 1-.56-.55v-1.09a.55.55 0 0 1 .56-.55h1.13a.55.55 0 0 1 .56.55v1.09zm0-4v.73a.55.55 0 0 1-.56.55h-1.12a.55.55 0 0 1-.56-.55V15c0-.6.14-1.09.84-1.09h.84a.55.55 0 0 0 .56-.55v-1.08a.55.55 0 0 0-.56-.54h-1.12a.55.55 0 0 0-.56.54.54.54 0 0 1-.56.55h-1.13a.44.44 0 0 1-.52-.54 3.39 3.39 0 0 1 6.7.54 3.27 3.27 0 0 1-2.25 3.07z"></path></svg>
                    </div>
                    <div class="app-link-label ">
                        <span>Help Center</span>
                    </div>
                </div>


            </div>
        </div>

    </div>


</template>

<script>
    export default {
        name: "flex-admin-side-nav",
        props: {
            activeLink: {
                type: String,
                required: false,
                default: null
            },
            mode: {
              type: String,
              required: false,
              default: "admin"
            }
        },
        data: function () {
            return {}
        },
        methods: {
            onNavLink: function(demoId){
                this.$emit("nav-click", demoId);
            }
        },
        computed: {
            activeAppLink: function(){
                if(this.activeLink){
                    return this.activeLink;
                }

                return "dashboard";
            }


        }
    }
</script>

<style scoped>




    .main-nav {
        font-size: 0.9em;
        position: absolute;
        width: calc((225/1580) * 100%);
        box-sizing: border-box;
        background-color: white;
        top: 0;
        height: 0;
        padding-bottom: calc((920/1580) * 100%);


        font-family: "Helvetica", "Arial", sans-serif;
        -webkit-font-smoothing: antialiased;

    }

    .nav-container {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }


    .icon-container svg {
        position: relative;
        height:100%;
        width: 30px;

    }

    .icon-container svg.help-svg {
        width: 24px;

    }





    .header-bar {
        position: relative;
        width: 100%;
        height: calc((60/920) * 100%);
        background-color: #0369b1;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .header-bar .logo {
        position: relative;
        width: calc((180/225) * 100%);
        height: calc((20/60) * 100%);

    }



    .app-group-header {
        font-size: 0.9em;
        margin: 0.9em;
        color: #7c8d99;
        box-sizing: border-box;
    }

    hr.app-group-header {
        border: 0;
        height: 1px;
        background-color: #D8D8D8;
        margin: calc((10/225) * 100%) calc((20/225) * 100%);
    }

    .app-links {
        position: relative;
        height: calc(((920 - 107)/920) * 100%);

    }

    .app-link {
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        justify-items: center;
        height: calc((40/(920 - 107)) * 100%);
        width: 100%;
        box-sizing: border-box;
        padding: calc((10/225) * 100%);
        padding-left: calc((14/225) * 100%);
        color: #7c8d99;
        cursor: pointer;
        fill: #7c8d99;


    }

    .app-link svg {

        cursor: pointer;
    }

    .app-link-icon {
        position: absolute;
        display: block;
        width: calc((30/225)*100%);
        height: calc((30/40)*100%);
        cursor: pointer;

    }


    .app-link-label {

        padding-left: calc((40/225) * 100%);
        cursor: pointer;

    }

    .app-link:hover {
        color: #0369b1;
        fill: #0369b1;
    }

    .app-link:hover .app-link-icon svg {

    }

    .app-link.link-disabled {
        cursor: default;
        pointer-events: none;
    }

    .app-link[data-selected="true"]{
        background-color: #f3f7fa;
        color: #0369b1;
        fill: #0369b1;
    }

    .app-link[data-selected="true"]:before {
        content: "";
        width: calc((5/225) * 100%);
        background-color: rgb(3, 105, 177);
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;

    }

    .hidden {
        display: none;
    }

</style>